import axios from 'axios';
import config from 'config';
import {userStore} from '../stores/user.store';
import {formUtilsService} from '../services/form-utils.service';

const base = config.apiBase;
let filesToUpload = {}

axios.interceptors.request.use(request => {
  console.log('Starting Request', request);
  if (request.url !== `${base}/user/profile` && request.url !== `${base}/user/logout`) {
    request.headers['Authorization'] = `Bearer ${userStore.bearer_token}`;
  }

  if (location.host.indexOf('localhost') !== -1 && request.url.indexOf('/api') !== -1) {
    console.log('Intercepting request to localhost');
    request.url = 'http://localhost:8080' + request.url;
  }
  
  return request;
})

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if(error.response) {
    let response = error.response;
    let old_req = response.config;

    if (response.status === 401 && old_req.url !== `${base}/user/profile`) {
      return userStore.reauthenticateUser().then(() => axios(old_req));
    }
  }
   throw error;
});

class ApiService {

  fetchProfile() {
    return axios.get(`${base}/user/profile`, {
      withCredentials: true
    });
  }

  logoutUser() {
    return axios.get(`${base}/user/logout`, {
      withCredentials: true
    });
  }

  getTrainingPortalContent() {
    return axios.get(`${base}/training/content`).then(res => res.data);
  }
  getSectionsIsAllowed(){
    return axios.get(`${base}/training/isOrgMatch`).then(
      (res)=> {
          return res.data;
      }
     
    );
  }

  getRoles() {
    return axios.get(`${base}/roles`).then(res => res.data);
  }

  getContentForRole(role) {
    let queryString = `${base}/training/role/content/${role.role}`;
    //FPSE-3168 leave off isPremierUser query parameter if the associated role doesn't depend on it
    if(role.isPremierUser !== null) {
      queryString += `?isPremierUser=${role.isPremierUser}`;
    }
    return axios.get(queryString).then(res => res.data);
  }

  getTrainingPortalFile(fileName) {
    return axios.get(`${base}/training/content/${fileName}`, {
      responseType: 'arraybuffer'
    });
  }

  editContentItem(data) {
    const dataCopy = formUtilsService.cloneToPlainObject(data);
    delete dataCopy.fieldList;
    return axios.put(`${base}/training/content`, dataCopy).then(res => res.data);
  }

  addContentItem(data) {
    const dataCopy = formUtilsService.cloneToPlainObject(data);
    delete dataCopy.id; //Remove temporary ID
    delete dataCopy.fieldList;
    return axios.put(`${base}/training/content`, dataCopy).then(res => res.data);
  }

  deleteContentItem(id) {
    return axios.delete(`${base}/training/content/${id}`).then(res => res.data);
  }

  uploadFile(file, fileMetaObject) {
    console.log(file, fileMetaObject);
    filesToUpload[fileMetaObject.id] = {file, fileMetaObject};
    return new Promise( res => res(file));
  }

  actualUploadOfFiles() {
    const promises = [];
    console.log(filesToUpload);
    for (const id in filesToUpload) {
      const file = filesToUpload[id].file;
      const fileMetaObject = filesToUpload[id].fileMetaObject;
      const safeFileName = encodeURIComponent(file.name);
      promises.push(axios.post(`${base}/training/content/file?name=${safeFileName}`, file, {
        headers: {
          'Content-Type': fileMetaObject.contentType || 'application/octet-stream'
        },
        onUploadProgress(progressEvent) {
          fileMetaObject.progress = (Math.ceil(100 * progressEvent.loaded / progressEvent.total));
        }
      }).then(res => {
        delete filesToUpload[id]
        return res.data;
      }))
    }
    return Promise.all(promises);
  }

  clearFilesToUpload() {
    filesToUpload = {};
  }

  deleteFile(fileName) {
    const safeFileName = encodeURIComponent(fileName);
    return axios.delete(`${base}/training/content/file?name=${safeFileName}`).then(res => res.data);
  }
}

export const apiService = new ApiService();
